import React, { useState, useEffect } from 'react'
import { groupBy, reduce, sortBy } from 'lodash'
import cx from 'classnames'
import { subscribe } from 'klaviyo-subscribe'

import { Link } from 'gatsby'

import { Image } from 'src/components/image'

import { subscribedToNewsletter } from 'src/components/analytics'
import { SEO } from 'src/components/SEO'
import { ArticleCard } from 'src/components/article/articleCard'

import { useSetPage, useStore } from 'src/context/siteContext'

import {
  LinkArrow,
  SmallArrow
} from 'src/components/svgs'

export interface PageProps {
  pageContext: {
    spices: any[]
  }
}

const ArticleIndex = ({
  pageContext,
}: PageProps) => {
  const [active, setActive] = useState('')
  const setPage = useSetPage()
  const [activeSpice, setActiveSpice] = useState(null)
  const {
    articles
  } = pageContext

  const [success, setSuccess] = useState(false)
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const form = e.currentTarget
    const { email } = form.elements
    subscribe(listId, email.value, customFields)
    .then(() => {
      subscribedToNewsletter(email.value)
      form.reset()
      setSuccess(true)
    })
  }

  useEffect(() => {
    setPage('article')
  }, [])

  const featured = articles[0]

  return (
    <div className="x">
      <div className='container--1300 x p2--800 mxa'>
        <div className='row gutter--none df x fw mt8 pt4'>
          {featured.image && (
            <div className='col c14 c7--800'>
              IMAGE
            </div>
          )}
          <div className={cx('col c14', {
            'c7--800': featured.image
          })}>
            <div className='df jcc tc bg--blue article__hero color--white aic y x'>
              <div className='p3'>
                <h2 className='mt2 mb2'>
                  {featured.title}
                </h2>
                <Link to={`/articles/${featured.slug}`} className='founders link-underline link-arrow caps'>Read Article <LinkArrow /></Link>
              </div>
            </div>
          </div>
        </div>
        <div className='row df fw gutter--none'>
          <div className='col c14 bb--800 bc c7--800'>
            <div className='p2 pl0--800 pt2 pb2 pr4 container--500'>
              <p className='s24 m0 p0 serif'>Piping hot news and promotions, served straight to your inbox</p>
            </div>
          </div>
          <div className='col c14 c7--800 bb--800 bl--800 bc'>
            <div className='x df jce article__form aic y'>
              <form className='p2 pr pt1 pb0 article__newsletter tr x container--500'>
                <input  aria-lable='Email Address' placeholder='Just add email' className='btn bln brn bc bg--transparent bb x pt1 pb1 s18' />
                <button type='submit' className='color--black y cg p15 pa top right mr1 bn bg--transparent p1 ac'>
                  <SmallArrow className='db' />
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className='row gutter--none mt8 mb2--800'>
          <div className='col c14 tc'>
            <svg width="213" height="84" viewBox="0 0 213 84" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.7348 37V36.1H10.1348C8.98482 36.1 8.43482 35.7 8.43482 34.8C8.43482 34.5 8.53482 34 8.83481 33.25L19.9848 4.1H23.9348C24.7348 4.1 25.2848 4.25 25.5848 4.45C25.8848 4.7 26.1348 5.2 26.2848 5.9C26.4848 6.9 26.8848 9.75 27.3848 14.45H28.1848L29.5848 1.55L28.8348 1.45C28.6348 2.45 27.8848 2.95 26.6848 2.95H22.2848C21.9848 2.95 21.3848 3 20.4848 3C19.5848 3 18.8848 3 18.2848 3C17.6348 3 16.7348 3 15.6348 3C14.5348 3 13.8348 2.95 13.5348 2.95H9.03482C8.03481 2.95 7.73481 2.55 8.03481 1.65L7.33481 1.4L0.234814 14.1L0.884815 14.55C2.53481 12.65 4.18482 10.75 5.78482 8.85C7.38481 6.95 8.18482 5.95 8.23482 5.9C8.93481 5.1 9.48482 4.6 9.98481 4.4C10.4848 4.2 11.1348 4.1 12.0348 4.1H15.7848L4.68481 32.95C4.23482 34.1 3.73481 34.9 3.18481 35.4C2.58481 35.9 1.83481 36.1 0.834815 36.1H0.134815V37H1.73481C2.08481 37 2.63481 37 3.43482 36.95C4.23482 36.9 4.88481 36.85 5.38482 36.85C5.88481 36.85 6.48482 36.9 7.23482 36.95C7.93481 37 8.48481 37 8.83481 37H10.7348ZM38.477 37.4C40.477 37.4 43.077 35.2 46.277 30.7L45.577 30.25C43.177 33.4 41.577 34.95 40.827 34.95C40.327 34.95 40.077 34.7 40.077 34.1C40.077 33.45 40.477 32.2 41.377 30.4L46.477 20.05C47.627 17.75 48.227 15.9 48.227 14.6C48.227 13.9 47.977 13.35 47.477 12.85C46.977 12.35 46.327 12.1 45.477 12.1C44.227 12.1 43.027 12.65 41.877 13.75C40.727 14.85 39.077 16.85 36.927 19.85L27.227 33.1L40.027 1.1L39.427 0.799998C38.377 2.25 36.027 2.95 32.327 2.95H31.027V3.8H32.577C33.627 3.8 34.177 4.15 34.177 4.8C34.177 5.15 34.027 5.65 33.777 6.3L21.527 37C21.727 37 22.077 37 22.527 36.95C22.977 36.95 23.327 36.9 23.527 36.9C23.727 36.9 24.077 36.95 24.627 36.95C25.127 37 25.527 37 25.777 37L37.877 20.4C39.077 18.7 40.077 17.4 40.827 16.5C41.577 15.6 42.127 15.05 42.427 14.85C42.727 14.65 42.977 14.5 43.277 14.5C43.777 14.5 44.077 14.85 44.077 15.5C44.077 16.15 43.477 17.6 42.377 19.85L37.477 29.9C36.377 32.1 35.877 33.8 35.877 34.9C35.877 35.65 36.077 36.25 36.527 36.7C36.977 37.2 37.627 37.4 38.477 37.4ZM53.3 37.4C56.7 37.4 60.3 34.65 64.2001 29.1L63.55 28.6C61.75 30.85 60.25 32.45 59.05 33.35C57.85 34.3 56.7 34.75 55.6 34.75C53.4 34.75 52.3 33.15 52.3 29.85C52.3 28.55 52.55 26.9 53.1 24.95C56.9 24.5 60.4 23.35 63.55 21.5C66.7 19.65 68.3 17.7 68.3 15.6C68.3 14.55 67.8 13.7 66.8 13.05C65.8001 12.45 64.6 12.1 63.1 12.1C60.75 12.1 58.4 13.1 56.05 15C53.65 16.95 51.75 19.4 50.25 22.35C48.75 25.3 48.05 28.15 48.05 30.9C48.05 32.85 48.5 34.4 49.5 35.6C50.45 36.8 51.7 37.4 53.3 37.4ZM64.85 14.75C64.85 16.5 63.65 18.4 61.3001 20.4C58.9 22.4 56.3 23.6 53.4 23.9C54.3 20.95 55.65 18.4 57.45 16.25C59.25 14.15 61.1 13.05 63.1 13.05C64.25 13.05 64.85 13.65 64.85 14.75ZM86.7666 75.9101V34.0524H98.4319C111.641 34.0524 118.846 41.8578 118.846 54.9812C118.846 68.1046 111.641 75.9101 98.4319 75.9101H86.7666ZM79.3043 82H98.8607C115.844 82 126.566 71.8787 126.566 54.9812C126.566 38.0838 115.844 27.9624 98.8607 27.9624H79.3043V82ZM131.078 44.5168V82H138.197V44.5168H131.078ZM130.906 36.0252H138.283V27.9624H130.906V36.0252ZM142.169 69.3912C142.856 78.6548 149.975 83.0293 159.324 83.0293C168.073 83.0293 174.678 78.9979 174.678 71.5356C174.678 64.7594 170.217 61.9289 162.669 60.6423L155.636 59.5272C151.776 58.841 149.889 57.2971 149.889 54.295C149.889 50.8641 152.977 48.7197 157.694 48.7197C164.042 48.7197 167.558 51.3787 168.416 57.1256L174.163 56.7825C173.477 48.1193 167.644 43.4875 157.694 43.4875C149.031 43.4875 143.284 48.1193 143.284 54.9812C143.284 61.4143 147.487 64.4163 154.521 65.5314L160.868 66.6465C165.5 67.5042 167.987 68.705 167.987 72.2218C167.987 75.9958 164.299 77.7971 159.324 77.7971C152.891 77.7971 148.86 74.7092 148.174 68.9624L142.169 69.3912ZM186.141 60.4707C186.141 53.6088 190.601 49.1486 196.262 49.1486C202.18 49.1486 205.182 53.0942 205.182 59.3557V82H212.302V58.7553C212.302 50.0063 208.356 43.4875 198.578 43.4875C193.003 43.4875 187.942 46.6611 186.141 51.2072V27.9624H179.021V82H186.141V60.4707Z" fill="#191818"/>
            </svg>
          </div>
        </div>
        <div className='row df fw mt2 pb4 bt bc gutter--none pl2 pr2 mt4--800 pl0--800 pr0--800'>
          {articles.map((article, i) => (
            <ArticleCard {...article} key={i} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ArticleIndex